import React, { useCallback, useState, useEffect } from 'react';
import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import firebase from './constants/firebase';
import {db} from './constants/firebase';
import theme from './Themer';
import { ThemeProvider } from '@material-ui/core/styles';
import Divider from '@material-ui/core/Divider';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(8),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: props => ({
    margin: theme.spacing(3, 0, 2),
    background: props.palette.gradient.default
  }),
}));

export default function ApplicationFee(props) {
  const currentTheme = theme();
  const classes = useStyles(currentTheme);
  const { history } = props;
  const [link, setLink] = useState(props.props.link ? props.props.link : "");
  const handleNext = props.props ? props.props.function: "";

  const handleSignUp = useCallback(
    async event => {
      event.preventDefault();
      const {link} = event.target.elements;
      try {
       
        var user = firebase.auth().currentUser;
        const dateObj = new Date();
        const options = {year: 'numeric', month: 'long', day: 'numeric'};
        const date = dateObj.toLocaleDateString(undefined, options)
        const time = dateObj.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

        db.collection("users").doc(user.email).update({
          ApplicationFee: {
            link: link.value,
            completed: true
          },
          LastUpdated: (date + " " + time)
        });

        console.log(link.value);
        handleNext();
      } catch (error) {
        alert(error);
      }
    },
    [history]
  );

   const onChangeFunction = (component, value) => {
        setLink(value);
    };

   const populateValues = () => {
        console.log("in here")
        const fs = firebase.firestore()
        var user = firebase.auth().currentUser;
        fs.collection("users").doc(user.email).get()
        .then((snapshot) => {
            if (snapshot.exists) { 
            const dat  = snapshot.data()
            setLink(dat.ApplicationFee.link ? dat.ApplicationFee.link : "")
            } else {
            console.log("No data available");
            }
        }).catch((error) => {
            console.log("error")
        })
   }

  return (
    <ThemeProvider theme={currentTheme}>
    <Container component="main" maxWidth="sm">
      <CssBaseline />
      <div className={classes.paper}>
      <Typography component="h1" variant="h3">
            Application Fee
        </Typography>
        <Box marginBottom={2}>
        <Divider variant="middle" />
        </Box>
        <Typography component="h1" variant="body1">
          Payments should be made via Cashnet. 
          The fee is $120 for the Regular deadline and $140 for the Late Deadline. 
          This fee will not be refunded under any circumstances.
          Instructions are below.
        </Typography>
        <Box pb={2}/>
        <Typography component="h1" variant="body1">
            <ol>
              <li>Go to Bhangra in the Burgh Org - Membership Dues</li>
              <ul>
                <li>One way to get to this is through the list of Carnegie Mellon University student organizations. 
                    One of the options should say Bhangra in the Burgh (13th from the top). 
                    Once there, click on the option that says Bhangra in the Burgh Org - Membership Dues (3rd option).</li>
                <li>Another way to navigate to this page is using the search function on the red navigation bar. 
                    Search Bhangra in the Burgh and find the link to Bhangra in the Burgh Membership Dues.</li>
              </ul>
              <li>Enter a price of either $120 or $140 depending on your time of submission. 
                  The executive board will be checking timings and will identify any incorrect payments based on deadlines.</li>
              <li>For the description, please enter the following: "(team name) - BIB XVI Registration fee"</li>
              <li>Please enter the full name of the person paying the registration fee</li>
              <li>Click Add to Basket.</li>
              <li>After reviewing the information and amount due, click checkout.</li>
              <li>The next page asks for login information. 
                  Either making an account or using guest access will result in the same process so proceed with whichever option is preferred.</li>
              <li>Enter in credit card information and proceed to checkout.</li>
              <li>Review information and submit.</li>
            </ol>
            Thank you for your accommodation using Cashnet. 
            This process should eliminate any convenience fees on your end. 
            Please contact us by phone or email if there are any issues with this process.
        </Typography>
        <Button
            fullWidth
            variant="contained"
            className={classes.submit}
            onClick={()=> window.open("https://commerce.cashnet.com/CMU231", "_blank")}>
          
            Go to Link
          </Button>
        <Box pb={2}/>
        <Typography component="h1" variant="body1">
          Note: If your team is accepted to compete in Bhangra in the Burgh XVI, you will additionally be required to submit a post-registration fee of $40 per member to be on the roster. 
          This is only if your team is accepted, and will be requested of you in a post-acceptance packet.
        </Typography>
        <Box pb={2}/>
        <Typography component="h1" variant="body1">
          Please submit a public viewable link to a screenshot of the payment confirmation. 
          If the link is not viewable, we will email you ASAP and require that you send us an updated link. 
          If the link is not sent within our time frame, you will be subject to a fine for consideration of your application.
        </Typography>
        <Box pb={2}/>
        <form className={classes.form} onSubmit={handleSignUp}>
          <TextField
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="link"
            label="Link"
            name="link"
            value = {link}
            onChange = {onChangeFunction}
            autoFocus
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
          >
            Submit
          </Button>
        </form>
        {/* <Button
            type="submit"
            fullWidth
            variant="contained"
            className={classes.submit}
            onClick={populateValues}
          >
            Not seeing anything? Retrieve Submitted Information
          </Button> */}
      </div>
    </Container>
    </ThemeProvider>
  );
}